<template>
  <section class="missingPage">
    <Header />
    <div class="container">
      <div class="row">
        <div class="col-sm-10 offset-sm-1 col-12">
          <div class="missingPage__title">
            404
          </div>
          <div class="missingPage__subtitle">
            Unfortunately, there are no saved objects on this link <br>
            Did you get here by accident?
          </div>
          <div class="missingPage__subtitle">
            You may start the calculation again.
          </div>
          <router-link to="/" class="missingPage__btn">Start calculation</router-link>
        </div>
      </div>
    </div>
    <Footer />
  </section>
</template>

<script>

import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  components: {
    Header,
    Footer,
  },
};
</script>

<style lang="sass" scoped>
.missingPage
  min-height: 100vh
  display: flex
  flex-direction: column
  justify-content: space-between
  &__title
    color: $red
    +media((font-size: (320: rem(80), 768: rem(150))))
    font-weight: 700
    text-shadow: rem(1) rem(1) 0 $black
  &__subtitle
    font-weight: 500
    color: $black
    padding-bottom: rem(20)
    +media((font-size: (320: rem(15), 768: rem(20))))
  &__btn
    background: $red
    color: #fff
    font-style: normal
    font-weight: bold
    font-size: rem(18)
    line-height: rem(22)
    text-decoration: none
    transition: .5s
    width: rem(240)
    height: rem(68)
    border-radius: rem(4)
    display: flex
    flex-direction: row
    justify-content: center
    align-items: center
    margin: auto
    margin-bottom: rem(20)
    &:hover
      background: $red-hover
</style>
